export default __webpack_public_path__ + "static/media/about-benefit.3cdd9390.svg";